// Standard UK postcode format (case-insensitive, optional single space).
export const ukPostcodeRegex = /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/;

export const isValidUkPostcode = (v) => ukPostcodeRegex.test(String(v || "").trim());

export const postcodeError = (v) => {
  if (!v) return "";
  return isValidUkPostcode(v) ? "" : "Please enter a valid UK postcode (e.g. SW1A 1AA).";
};

// Returns an error string for a date-of-birth value, or "" when valid/empty.
export const dobError = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "Please enter a valid date of birth.";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (d > today) return "Date of birth cannot be in the future.";
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  if (age < 18) return "You must be at least 18 years old to submit this form.";
  return "";
};

export const isValidDob = (v) => !!v && !dobError(v);
